import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import useMixpanel from "./useMixpanel";
import {
  setButtonClick,
  setButtonNoClick,
  setButtonYesClick,
} from "../store/buttonSlice";
import Cookies from "js-cookie";

export const useHandleRedirect = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const nextPage = useSelector((state) => state.appRoute.nextPage);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { trackP1Event } = useMixpanel();

  const handleRedirectClick = (
    queryParamsName,
    queryParamsData,
    eventName,
    properties
  ) => {
    dispatch(setButtonClick(false));
    dispatch(setButtonNoClick(false));
    dispatch(setButtonYesClick(false));

    let visitorId = queryParams.get("visitor_id") || Cookies.get("visitor_id");
    if (visitorId) queryParams.set("visitor_id", visitorId);

    if (!visitorId) {
      visitorId = crypto.randomUUID();
    }
    Cookies.set("visitor_id", visitorId, { expires: 365 });

    if (queryParamsName) {
      queryParams.set(queryParamsName, queryParamsData);
    }

    if (eventName) {
      trackP1Event(
        eventName,
        eventName === "web_pricing_pass" ? { ...properties } : properties
      );
    }
    history.push({
      pathname: nextPage,
      search: `?${queryParams.toString()}`,
    });
  };
  return { handleRedirectClick };
};
